import React from 'react';
import Grid from '@material-ui/core/Grid';

const Dashboard = ({ children, direction }) => (
  <Grid
    container
    direction={direction}
    spacing={{ xs: 2, md: 3 }} 
    style={{
      padding: 30,
    }}
    justify="space-around"
    alignItems="flex-start"
  >
    {children}
  </Grid>
);

export default Dashboard;
